import { calculateTimeRemaining } from '@/lib/utils';
import { cn } from '@/lib/utils';
import { useEffect, useState } from 'react';

export const SlaTimer = ({ deadline, status, className }) => {
  const [timeInfo, setTimeInfo] = useState(() => calculateTimeRemaining(deadline));

  useEffect(() => {
    if (['completed', 'closed', 'rejected'].includes(status)) {
      return;
    }
    const interval = setInterval(() => {
      setTimeInfo(calculateTimeRemaining(deadline));
    }, 60000); // Update every minute

    return () => clearInterval(interval);
  }, [deadline, status]);

  if (['completed', 'closed', 'rejected'].includes(status)) {
    return (
      <div
        className={cn(
          'inline-flex items-center px-3 py-1.5 font-bold text-xs uppercase tracking-wider rounded-sm bg-slate-100 text-slate-500 border border-slate-200',
          className
        )}
        data-testid="sla-timer-stopped"
      >
        ✅ SLA Stopped
      </div>
    );
  }

  if (!timeInfo) return null;

  const getColorClass = () => {
    if (timeInfo.expired) return 'bg-red-500 text-white';
    if (timeInfo.urgent) return 'bg-yellow-500 text-black';
    return 'bg-green-100 text-green-800';
  };

  return (
    <div
      className={cn(
        'inline-flex items-center px-3 py-1.5 font-bold text-sm rounded-sm',
        getColorClass(),
        className
      )}
      data-testid="sla-timer"
    >
      {timeInfo.expired ? '⚠️ ' : '⏱️ '}
      {timeInfo.text}
    </div>
  );
};